import Link from "@/components/AppLink";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";

const Banner = () => {
  return (
    <section className="banner-section index-9">
      <div className="overlay">
        <div className="banner-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-10">
                <div className="main-content">
                  <h1>Earnings insights built for freelancers</h1>
                  <p className="xxlr">
                    See who pays on time, where fees eat margin, and how FX moves
                    your real income—without building a spreadsheet every month.
                  </p>
                  <Link href={getDashboardPathUrl("/register-2")} className="cmn-btn">
                    Open your dashboard
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
